import urls from '../api_urls/claim'
import { _post } from '@/axios/request'

// 获取claim列表
export function getTableData (params) {
  return _post(urls.GET_LIST, params)
}

// 新增claim
export function saveClaim (params) {
  return _post(urls.SAVE_CLAIM, params)
}

// 获取claim详情
export function getClaimDetail (params) {
  return _post(urls.GET_CLAIM_DETAIL, params)
}

// 获取英文标题
export function getEnTitle (params) {
  return _post(urls.GET_TITLE, params)
}

// 获取matching列表
export function getMatchingList (params) {
  return _post(urls.GET_MATCHING_LIST, params)
}

// 修改matching状态
export function changeMatchingStatus (params) {
  return _post(urls.CHANGE_MATCHING_STATUS, params)
}

// 获取matching详情
export function getMatchingDetail (params) {
  return _post(urls.GET_MATCHING_DETAIL, params)
}

// 编辑matching
export function saveMatching (params) {
  return _post(urls.SAVE_MATCHING, params)
}

export function delTranslation (params) {
  return _post(urls.DEL_TRANSLATION, params)
}

export function addTranslation (params) {
  return _post(urls.ADD_TRANSLATION, params)
}
export function editTranslation (params) {
  return _post(urls.EDIT_TRANSLATION, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/claim.js